module.exports = __webpack_public_path__ + "img/sweden-mental-and-behavioural-disorders-female.6347c74a.png";